import React from 'react';
import { LockIcon, MailIcon } from 'lucide-react';
import { PaymentBadges } from './PaymentBadges';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4 border-t border-gray-800" data-id="element-72">
      <div className="max-w-4xl mx-auto" data-id="element-73">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8 text-center md:text-left" data-id="element-74">
          {/* Security & Payments */}
          <div className="flex flex-col items-center md:items-start" data-id="element-75">
            <div className="flex items-center gap-2 text-white font-bold mb-4" data-id="element-76">
              <LockIcon className="w-5 h-5 text-green-500" data-id="element-77" />
              <span data-id="element-78">Pagamento Sicuro</span>
            </div>
            <p className="text-sm mb-4" data-id="element-79">
              Tutti i pagamenti sono processati in modo sicuro con crittografia
              SSL a 256 bit.
            </p>
            <PaymentBadges className="justify-center md:justify-start" data-id="element-80" />
          </div>

          {/* Links */}
          <div className="flex flex-col items-center md:items-start" data-id="element-81">
            <h4 className="text-white font-bold mb-4" data-id="element-82">Link Utili</h4>
            <ul className="space-y-2 text-sm" data-id="element-83">
              <li data-id="element-84">
                <a href="#" className="hover:text-white transition-colors" data-id="element-85">
                  Termini e Condizioni
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-white transition-colors" data-id="element-87">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-white transition-colors" data-id="element-89">
                  Informativa sui Cookie
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="flex flex-col items-center md:items-start" data-id="element-90">
            <h4 className="text-white font-bold mb-4" data-id="element-91">Contattaci</h4>
            <p className="text-sm mb-2" data-id="element-92">Hai bisogno di aiuto?</p>
            <a href="mailto:info@activapleno.com" className="flex items-center gap-2 text-sm hover:text-white transition-colors" data-id="element-93">
              <MailIcon className="w-4 h-4" data-id="element-94" />
              info@activapleno.com
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-xs space-y-4" data-id="element-95">
          <p data-id="element-96">
            <strong data-id="element-97">Disclaimer:</strong> Questo &egrave; un prodotto digitale.
            Nessun articolo fisico verr&agrave; spedito. L&apos;accesso al
            materiale &egrave; immediato dopo il completamento del pagamento.
          </p>
          <p data-id="element-98">&copy; {currentYear} Activa Pleno. Tutti i diritti riservati.</p>
          <p className="opacity-50 text-[10px]" data-id="element-99">
            Questo sito non fa parte del sito web di Facebook o Facebook Inc.
            Inoltre, questo sito NON &egrave; approvato da Facebook in alcun
            modo. FACEBOOK &egrave; un marchio registrato di FACEBOOK, Inc.
          </p>
        </div>
      </div>
    </footer>;
}